<app-skeleton-new-principal-image />

<div class="w-full max-w-[800px] flex overflow-x-auto hidden-scrollbar gap-4">
  @for (item of cardItem; track $index) {
  <div class="cursor-pointer min-w-[300px] max-sm:min-w-[200px]">
    <app-skeleton-new-card />
  </div>
  }
</div>

<div class="mt-3"></div>

<app-skeleton-new-card-horizontal />
